export class IndustryContractTemplateSearchCriteria {
  NetworkName: string;
  PayerGroupName: string;
  ContractTypeIds: number[];
}
